export class PUIDataReq {
  constructor(
    public id: number,
    public name: string,
    public address: string,
    public tel: string,
    public mail: string,
    public fax?: string,
    public instagramURL?: string,
    public twitterURL?: string,
    public facebookURL?: string,
    public blogURL?: string,
  ) {}
}
export class PostUpsertInfomationReq {
  constructor(
    public data: PUIDataReq
  ) {
  }
}
